import React, { FC, memo } from 'react';
import CustomField, {
    TemplateProps as CustomFieldTemplateProps,
} from 'src/components/common/CustomField';

interface TemplateProps {
    value?: any;
    onChanged?: (v: any) => void;
    attributes?: Omit<CustomFieldTemplateProps, 'value' | 'onChange'>;
}

const Template: FC<TemplateProps> = (props) => {
    const { value, onChanged, attributes } = props;

    return <CustomField value={value} onChange={onChanged} {...attributes} />;
};

export default memo(Template);
